__turbopack_context__.v({
  "globeSlot": "layout-module__mDkEvq__globeSlot",
  "heartRateSlot": "layout-module__mDkEvq__heartRateSlot",
  "heroForeground": "layout-module__mDkEvq__heroForeground",
  "indicatorsContainer": "layout-module__mDkEvq__indicatorsContainer",
  "innerLayout": "layout-module__mDkEvq__innerLayout",
  "scroll": "layout-module__mDkEvq__scroll",
  "scroll-fade-out": "layout-module__mDkEvq__scroll-fade-out",
});
